<section class="row">
  <div class="col-md-12 mb-3">
    <h2 uni-heading alignText="center" class="text-center">Asignación de Permisos</h2>
  </div>

  <div class="col-md-12 mx-auto">
    <div class="row">
      <div class="col-lg-7">
        <form class="row" #formNuevaCompania="ngForm" autocomplete="off">
          <div class="col-md-12" *ngIf="isOperativeCreation && isUserCanales">
            <div class="form-group">
              <label for="identification-type">Administrador: </label><span class="required-mark"> * </span>
              <ng-select
                name="admin"
                [items]="identificationTypes$ | async"
                #admin="ngModel"
                #adminSelect
                bindLabel="displayLabel"
                placeholder="Seleccione el Administrador"
                [(ngModel)]="selectedAdmin"
                [class.is-invalid]="admin.invalid && admin.touched"
                [loading]="loadingEscrows"
                (change)="onAdminChanged(selectedAdmin.id)"
                [disabled]="isEditing"
                required
              ></ng-select>
            </div>
          </div>

          <div class="col-md-12">
            <div class="form-group">
              <label for="escrow">Fideicomiso: <span class="required-mark">*</span></label>
              <ng-select
                name="escrow"
                [items]="escrows"
                #escrow="ngModel"
                #escrowSelect
                bindLabel="sNombreCorto"
                placeholder="Seleccionar el fideicomiso"
                [(ngModel)]="selectedFideicomiso"
                [class.is-invalid]="escrow.invalid && escrow.touched"
                [loading]="loadingEscrows"
                (change)="onEscrowChanged(selectedFideicomiso.id)"
                required
              >
              </ng-select>
            </div>
          </div>
          <div class="col-md-12">
            <div class="form-group">
              <label for="dependency">Áreas de la Solicitud: <span class="required-mark">*</span></label>
              <ng-select
                name="dependency"
                [items]="dependencies"
                #dependency="ngModel"
                #dependenciesSelect
                bindLabel="sNombre"
                placeholder="Seleccionar una o varias área"
                [(ngModel)]="selectedDependency"
                [class.is-invalid]="dependency.invalid && dependency.touched"
                [loading]="loadingDependency"
                [multiple]="true"
                required
              >
              </ng-select>
            </div>
          </div>
        </form>

        <div class="mt-4" *ngIf="selectedFideicomiso !== null">
          <label for="cargarAreas">Acciones rapidas: </label>
          <div class="shadow-box p-3 mb-4">
            Cargar todas las áreas:
            <ui-switch
              name="cargarAreas"
              [(ngModel)]="cargarAreas"
              [size]="'small'"
              [disabled]="false"
              (change)="onSwitchChange($event)"
              class="float-right"
            >
            </ui-switch>
          </div>
        </div>

        <!-- PERMISOS -->
        <div class="mt-4">
          <span>Permisos: </span>
          <div class="shadow-box p-3 mb-4" *ngFor="let permiso of permisosFiduciaria">
            {{ permiso.descripcion }}
            <span class="mt-3">
              <ui-switch
                (change)="onPermissionChange(permiso)"
                [loading]="loading"
                [(ngModel)]="permiso.checked"
                [size]="'small'"
                [disabled]="false"
                class="float-right"
              >
              </ui-switch>
            </span>
          </div>
        </div>

        <div class="mt-5 buttons-container">
          <button
            uni-button
            icon="chevron-right"
            class="float-right btn-lg-block"
            [disabled]="!fideicomiso.length"
            (click)="guardarCambios()"
          >
            Guardar Cambios
          </button>
          <button
            uni-button
            icon="chevron-right"
            variant="info"
            class="float-right mr-0 mt-4 mt-xl-0 btn-lg-block"
            [disabled]="formNuevaCompania.invalid"
            (click)="asignarFideicomiso()"
          >
            Asignar Fideicomiso
          </button>
        </div>
      </div>

      <div class="col-lg-5">
        <div class="d-none d-lg-block">
          <b>Fideicomisos Asignados:</b>
          <div class="dotted-box" *ngIf="!fideicomiso.length">
            <div class="no-permisos text-center">Actualmente no hay permisos asignados</div>
          </div>
        </div>

        <uni-accordion
          [closeOthers]="true"
          [showExpandedIcon]="false"
          title="Fideicomisos Asignados"
          closedText="Ver Fideicomisos"
          openedText="Ocultar Fideicomisos"
          *ngIf="fideicomiso.length"
        >
          <uni-accordion-group [isExpanded]="false" [heading]="escrowItem.sNombreCorto" *ngFor="let escrowItem of fideicomiso">
            <uni-accordion [showExpandedIcon]="true" [closeOthers]="true" [isChild]="true">
              <uni-accordion-group
                [isExpanded]="false"
                [heading]="dependencyItem.sNombre"
                *ngFor="let dependencyItem of escrowItem.dependencies"
              >
                <div class="d-flex align-items-center justify-content-between p-2">
                  <div class="d-flex align-items-center">
                    <span class="font-weight-bold mr-2">Código:</span>
                    <span>{{ dependencyItem.sCodigo }}</span>
                  </div>
                  <button
                    class="p-2"
                    tooltip="Borrar"
                    uni-icon-button
                    variant="danger"
                    (click)="eliminarDependency(escrowItem, dependencyItem)"
                  >
                    <uni-icon name="trash"></uni-icon>
                  </button>
                </div>
              </uni-accordion-group>
            </uni-accordion>
          </uni-accordion-group>
        </uni-accordion>
      </div>
    </div>
  </div>
</section>
